import {
    useCoursesForCartUpsellByIds,
    useFetchBundleFromCourse,
    type CourseForCartUpsell,
} from '@udemy/react-certification-preparation';
import {useExamByTopicId} from '@udemy/react-certification-vouchers';

export interface OtherCourseInBundle {
    course: CourseForCartUpsell | null;
    isLoading: boolean;
    error: Error | null;
}

export function useBundleForCourseUpsell(inCartCourseId: number) {
    const {bundle, isLoading: bundleLoading} = useFetchBundleFromCourse(inCartCourseId, {
        enabled: !!inCartCourseId,
    });
    const relatedTopicId = bundleLoading ? undefined : bundle?.topicId;
    const examInTopic = useExamByTopicId(relatedTopicId);

    const hasBundle = !bundleLoading && Boolean(bundle);
    const hasVoucherForTopic = Boolean(examInTopic.voucherPool ?? examInTopic.defaultPool);
    const examSettled = !relatedTopicId || !examInTopic.isLoading;
    const hasCertificationBundle = hasBundle && examSettled && hasVoucherForTopic;

    const otherCourseEntry =
        hasBundle && bundle ? bundle.contents.find((c) => c.id !== inCartCourseId) : undefined;

    const idsToFetch: number[] = otherCourseEntry ? [otherCourseEntry.id] : [];

    const {
        courses,
        isLoading: coursesFetchLoading,
        error,
    } = useCoursesForCartUpsellByIds(idsToFetch);

    const otherCourseInBundle: OtherCourseInBundle = {
        course: courses[0] ?? null,
        isLoading:
            bundleLoading ||
            (idsToFetch.length > 0
                ? coursesFetchLoading
                : Boolean(relatedTopicId) && examInTopic.isLoading),
        error,
    };

    return {
        bundle,
        bundleLoading,
        relatedTopicId,
        examInTopic,
        hasCertificationBundle,
        otherCourseInBundle,
    };
}
